// services/catholicFestivityService.js

import api from './apiService';

// Fetch Catholic festivities for a specific month
export const fetchCatholicFestivities = async (year, month) => {
  try {
    const response = await api.get('/catholic-festivities', {
      params: { year, month }
    });
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

// New method to fetch Catholic festivities for a specific date range (e.g., next 30 days)
export const fetchCatholicFestivitiesInRange = async (startDate = null, days = 30) => {
  try {
    // If no startDate is provided, use today
    const params = { days };
    if (startDate) {
      // Format date as YYYY-MM-DD if it's a Date object
      if (startDate instanceof Date) {
        params.start_date = startDate.toISOString().split('T')[0];
      } else {
        params.start_date = startDate;
      }
    }
    
    const response = await api.get('/catholic-festivities/range', { params });
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Add a new Catholic festivity (admin only)
export const addCatholicFestivity = async (festivityData) => {
  try {
    const response = await api.post('/catholic-festivities', festivityData);
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update an existing festivity (admin only)
export const updateCatholicFestivity = async (festivityId, festivityData) => {
  try {
    const response = await api.put(`/catholic-festivities/${festivityId}`, festivityData);
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a festivity (admin only)
export const deleteCatholicFestivity = async (festivityId) => {
  try {
    const response = await api.delete(`/catholic-festivities/${festivityId}`);
    
    return response.data;
  } catch (error) {
    throw error;
  }
};